import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('../layout/index.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard/index.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('../views/users/index.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'technician',
        name: 'Technician',
        component: () => import('../views/technician/index.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('../views/order/index.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'order-comments',
        name: 'OrderComments',
        component: () => import('../views/order_comment/index.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'finance',
        name: 'Finance',
        component: () => import('../views/finance/index.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  
  if (to.path === '/login') {
    if (isLoggedIn) {
      next({ path: '/dashboard' })
    } else {
      next()
    }
  } else {
    // 检查路由是否需要认证
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!isLoggedIn) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
})

export default router
